import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DeviceService from '../../../../services/device.service';
import { useTranslation } from 'react-i18next';
import { toastSuccess } from '../../../../App';
import AssetModal from './asset.modal';
import DeleteDeviceModal from './DeleteDeviceModal';

// TODO: store this in a config file
const baseAssetUrl = 'https://operator-uploads.s3.us-east-2.amazonaws.com';

export default function BloomDescription() {
  const { t } = useTranslation();
  const { siteId, deviceId } = useParams();
  const navigate = useNavigate();
  const [device, setDevice] = useState<any>();
  const [name, setName] = useState<string>('');
  const [notes, setNotes] = useState<string>('');
  const [isAssetModalOpen, setIsAssetModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const canSave = name.trim() !== '';

  const handleSave = () => {
    if (siteId && deviceId) {
      const updatedData: any = {
        name,
        notes,
        type: device.type,
        subject: {}
      };

      DeviceService.updateDevice(siteId, deviceId, updatedData).then(
        (response) => {
          response.json().then((data) => {
            setDevice(data);
            toastSuccess(t('sites.deviceUpdated'));
          });
        },
      );
    }
  };

  const fetchData = async () => {
    if (siteId && deviceId) {
      const deviceResponse = await DeviceService.getDevice(siteId, deviceId);
      const data = await deviceResponse.json();
      setDevice(data);
      setName(data.name);
      setNotes(data.notes);
    }
  };

  const handleDelete = async () => {
    if (siteId && deviceId) {
      try {
        const response = await DeviceService.deleteDevice(siteId, deviceId);
        if (response.ok) {
          toastSuccess(t('sites.deviceDeleted'));
          navigate(`/sites/${siteId}`);
        }
      } catch (error) {
        console.error('Failed to delete device:', error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="flex flex-row items-center justify-between pt-3">
        <h2 className="text-lg font-bold leading-6 text-gray-900">
          {t('sites.device')}
        </h2>

        <div>
          <button
            type="button"
            className={`rounded-md border border-transparent bg-indigo-600 hover:bg-indigo-700 py-2 px-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm mr-2`}
            onClick={() => setIsAssetModalOpen(true)}
          >
            View Images
          </button>
          <button
            type="button"
            className={`rounded-md border border-transparent ${
              canSave ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-indigo-200'
            } py-2 px-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm mr-2`}
            onClick={handleSave}
            disabled={!canSave}
          >
            {t('save')}
          </button>
          <button
            type="button"
            className="rounded-md border border-transparent bg-red-600 hover:bg-red-700 py-2 px-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
            onClick={() => setIsDeleteModalOpen(true)}
          >
            {t('sites.deleteDevice')}
          </button>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-6 gap-6">
        <div className="col-span-3 sm:col-span-2">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            {t('sites.name')}
          </label>

          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
          />
        </div>
        <div className="col-span-6 sm:col-span-3">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            {t('sites.notes')}
          </label>

          <input
            type="text"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
          />
        </div>
      </div>

      <AssetModal
        imagePaths={device?.attachments || []}
        baseUrl={baseAssetUrl}
        isOpen={isAssetModalOpen}
        setOpen={setIsAssetModalOpen}
      />

      <DeleteDeviceModal
        isOpen={isDeleteModalOpen}
        setOpen={setIsDeleteModalOpen}
        onConfirm={handleDelete}
        deviceName={name}
      />
    </>
  );
}
